
import { metaDataMixin } from '~/mixins'

export default {
  mixins: [
    metaDataMixin,
  ],
  async asyncData ({ $config, $api, store, route }) {
    const { data: { items: persons = [] } = {} } = await $api.persons.getAll(
      {
        limit: 300,
        sort: 'title',
        community: $config.preprCommunityId,
      },
    )

    // Set breadcrumbs
    await store.dispatch('breadcrumbs/set', {
      path: route.path,
      width: 10,
      items: [
        {
          to: '/',
          label: 'Ik mis je',
        },
        {
          label: 'Bloggers',
        },
      ],
    })

    const team = []
    const guests = []

    persons.map((person) => {
      if (person.roles?.some(role => role.body === 'Gastauteur')) {
        return guests.push(person)
      } else {
        return team.push(person)
      }
    })

    guests.sort((a, b) => {
      return new Date(a.changedOn).getTime() > new Date(b.changedOn).getTime() ? -1 : 1
    })

    return {
      guests,
      team,
    }
  },
  data () {
    return {
      team: [],
      guests: [],
      socials: [
        {
          platform: 'facebook',
          link: 'https://www.facebook.com/EOikmisje',
        },
        {
          platform: 'instagram',
          link: 'https://www.instagram.com/eo_ikmisje/',
        },
        {
          platform: 'spotify',
          link: 'https://open.spotify.com/playlist/6rdKMdyprhEMDMzmV8yGtH',
        },
      ],
      seo: {
        title: 'Bloggers',
        description: 'De bloggers die schrijven voor Ik mis je. Zij schrijven herkenbare blogs over het verlies van een partner, ouder of kind.',
      },
      social: {
        image: 'https://584lyuyf5181.b-cdn.net/548cf3ba-83d3-4d41-a0c8-80162d1b443d',
      },
    }
  },
  methods: {
    getSubtitle (person) {
      if (person.subtitle) {
        return person.subtitle
      } else {
        return person.roles?.map(role => {
          switch (role.body) {
            case 'Auteur':
              return 'Redactie'
            case 'Stagiair':
              return 'Stagiair'
            case 'Gastauteur':
              return 'Blogger'
            default:
              return role.body
          }
        }).join(', ')
      }
    },
  },
}
